module.exports = __webpack_public_path__ + "static/media/mart.8699e321.png";